import React, { CSSProperties, MouseEvent } from "react";
import styles from "./Icon.module.css";
import * as UntitledUIIcons from "@src/assets/images/icons/untitled_ui_icons";

export type IconProps = {
  className?: string;
  style?: CSSProperties;
  type?: "filled" | "outlined";
  color?: string;
  /**
   * Material Icon Name.
   * See: https://fonts.google.com/icons?selected=Material+Icons
   */
  name?: string;
  size?: string | number;
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  onClick?: (event: MouseEvent<HTMLSpanElement>) => void;
  onHover?: (hovering: boolean) => void;
  cursor?: "pointer" | "default" | "hand";
  float?: "left" | "right";
  textAlign?: "left" | "center" | "right";

  fontWeight?: number;
  dataCy?: string;
};

/**
 * @deprecated use {@link UntitledUIIcons} instead
 */
export const Icon = ({
  name,
  className,
  type,
  color,
  fontWeight,
  size,
  textAlign,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  float,
  cursor,
  onClick,
  onHover,
  dataCy,
}: IconProps) => {
  const iconType = type ?? "filled";
  const cssProperties: React.CSSProperties = {
    color,
    fontSize: size,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    cursor: cursor ?? (onClick ? "pointer" : "inherit"),
    float,
    fontVariationSettings: iconType === "filled" ? "'FILL' 1" : "'FILL' 0",
    fontWeight,
    userSelect: "none",
    textAlign,
    display: textAlign === "center" ? "inline-block" : undefined,
  };

  return (
    <span
      data-cy={dataCy}
      style={cssProperties}
      onMouseEnter={() => onHover?.(true)}
      onMouseLeave={() => onHover?.(false)}
      className={`${styles.container} material-symbols-outlined ${className}`}
      onClick={onClick}
    >
      {name}
    </span>
  );
};
